"use strict";

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnScreen = exports.useOnScreen = void 0;

var react_1 = __importDefault(require("react")); // Source: https://usehooks.com/useOnScreen/

/**
 * Determines if the passed element is visible in the viewport or not.
 * @param ref A reference to the container DOM element.
 * @param rootMargin Offset margin. For example, "-300px" means at least 300px of the element needs
 *                   to be on the screen.
 * @param debounce The trailing debounce, in milliseconds, so that we don't keep triggering. Defaults to 500.
 * @returns A boolean, indicating if the element is on-screen or not.
 */


function useOnScreen(ref) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';
  var debounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

  // State and setter for storing whether element is visible
  var _react_1$default$useS = react_1["default"].useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      isIntersecting = _react_1$default$useS2[0],
      setIntersecting = _react_1$default$useS2[1]; // Prevent anything from happening after we're unmounted.


  react_1["default"].useEffect(function () {
    return function () {
      shouldWait.current = true;
    };
  }, []);
  var shouldWait = react_1["default"].useRef(false);
  react_1["default"].useEffect(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      if (!shouldWait.current) {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting);
        shouldWait.current = true;
        setTimeout(function () {
          shouldWait.current = false;
        }, debounce);
      }
    }, {
      rootMargin: rootMargin
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref.current]); // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting;
}

exports.useOnScreen = useOnScreen;

function OnScreen(_ref3) {
  var children = _ref3.children,
      rootMargin = _ref3.rootMargin,
      debounce = _ref3.debounce;
  var containerRef = react_1["default"].useRef(null);
  var onScreen = useOnScreen(containerRef, rootMargin, debounce);
  return react_1["default"].createElement("div", {
    ref: containerRef
  }, onScreen ? children : null);
}

exports.OnScreen = OnScreen;